export const Topic = {
    "话题标题":"話題標題",
    "导入已有话题":"導入已有話題",
    "话题详情":"話題詳情",
    "添加话题讨论":"添加話題討論",
    "请输入留言":"請輸入留言",
    "发表":"發表",
}